import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72451810")

_pushScopeId("data-v-72451810")
const _hoisted_1 = { class: "table" }
const _hoisted_2 = {
  key: 0,
  class: "spinnerWrapper"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createVNode("col", {
  span: "1",
  class: "attribute"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("col", {
  span: "1",
  class: "values"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "tablehead" }, [
    /*#__PURE__*/_createVNode("th", { class: "attributes" }, "Attribute"),
    /*#__PURE__*/_createVNode("th", null, "Daten")
  ])
], -1)
const _hoisted_7 = { class: "same-predicate-list" }
const _hoisted_8 = {
  key: 0,
  class: "box"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_InstanceInfoTable = _resolveComponent("InstanceInfoTable", true)

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.instance.getAttributes().size==0 && _ctx.loading>0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_LoadingSpinner)
        ]))
      : (_openBlock(), _createBlock("table", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.instance.getAttributes(), ([property, attributes]) => {
              return (_openBlock(), _createBlock("tr", {
                key: property.iri
              }, [
                _createVNode("td", {
                  class: "attributes",
                  title: property.iri
                }, _toDisplayString(property.label), 9, ["title"]),
                _createVNode("td", null, [
                  _createVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(attributes, (attribute) => {
                      return (_openBlock(), _createBlock("li", {
                        key: attribute.iri || attribute,
                        class: {object: _ctx.isObject(attribute)}
                      }, [
                        (_ctx.isObject(attribute))
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: attribute.iri,
                              target: "_blank",
                              class: "material-icons",
                              title: attribute.iri
                            }, "link", 8, ["href", "title"]))
                          : _createCommentVNode("", true),
                        (attribute?.hasProps)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _createVNode("span", {
                                onClick: ($event: any) => (_ctx.toggleSubtable(property.iri,attribute.iri)),
                                class: ["material-icons toggle-subtable hover", {expanded: _ctx.showSubtable(property.iri,attribute.iri)}]
                              }, " chevron_right ", 10, ["onClick"]),
                              _createVNode("a", {
                                onClick: _withModifiers(($event: any) => (_ctx.showInstance(attribute)), ["prevent","stop"]),
                                href: _ctx.getAttributeStateURL(attribute.iri),
                                title: attribute.iri
                              }, _toDisplayString(attribute.label), 9, ["onClick", "href", "title"]),
                              (_ctx.showSubtable(property.iri,attribute.iri))
                                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                                    _createVNode("h5", null, "Eigenschaften von '" + _toDisplayString(attribute.label) + "'", 1),
                                    (_ctx.showSubtable(property.iri,attribute.iri))
                                      ? (_openBlock(), _createBlock(_component_InstanceInfoTable, {
                                          key: 0,
                                          instance: attribute,
                                          onShowInstance: _ctx.showInstance
                                        }, null, 8, ["instance", "onShowInstance"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createBlock("span", {
                              key: 2,
                              title: attribute?.iri
                            }, _toDisplayString(attribute.label || attribute), 9, ["title"]))
                      ], 2))
                    }), 128))
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
  ]))
})